import { Component, Input } from '@angular/core';
import { OrderDetailsSlotGadgetComponent } from '../order-details/order-details-slot-gadget.component';

@Component({
  selector: 'new-offer-slot-gadget',
  templateUrl: './new-offer-slot-gadget.component.html',
})
export class NewOfferSlotGadgetComponent extends OrderDetailsSlotGadgetComponent {

  @Input() public bundleNumber: number;

  @Input() public offerId: string;

  constructor() {
    super();
  }

  public removeGadget(event: Event) {
    event.preventDefault();

    this.commonGadgetsService.removeGadget({
      bundleNo: this.bundleNumber,
      deviceId: this.gadget.sku,
      offerId: this.offerId
    });
  }
}
